var map = {
	"./amphibian.png": 8375,
	"./bird.png": 8403,
	"./dogAndCat.png": 3608,
	"./fish.png": 5625,
	"./guineaPig.png": 653,
	"./image 5.png": 1622,
	"./logo/logo192.png": 9392,
	"./logo/logo512.png": 9633,
	"./mam.png": 629,
	"./personIcon.png": 9960,
	"./rabbit.png": 9935,
	"./reptile.png": 2977,
	"./species/Birds/birds.png": 3889,
	"./species/GuineaPig/guineaPig.png": 9882,
	"./species/Rabbit/rabbit.png": 9898,
	"./species/Reptile/reptile.png": 1097,
	"./turtle.png": 5894
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;